import { useDelete_Block_TagMutation } from '@geerd-nx/shareable-graphql';
export function useDeleteBlockTag() {
  const [mutate] = useDelete_Block_TagMutation({
    update: (cache, { data }) => {
      const normalizedId = cache.identify({
        id: data?.delete_block_tag?.returning[0]?.id,
        __typename: 'block_tag',
      });
      cache.evict({ id: normalizedId });
      cache.gc();
    },
  });
  return mutate;
}
